import { NOTIFICATION_HANDLER } from '@Constants/types';

export const NOTIFICATION_TYPE = {
    ERROR: 'ERROR',
    DISPLAY_ERROR: 'DISPLAY_ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO'
};

const initialState = {
    errorMessageInfo: '',
    hasNotification: false,
    notificationType: NOTIFICATION_TYPE.ERROR
};

export default function notificationHandlingReducer(state = initialState, action) {
    switch (action.type) {
        case NOTIFICATION_HANDLER.ERROR:
            return {
                ...state,
                hasNotification: true,
                errorMessageInfo: action.payload,
                notificationType: NOTIFICATION_TYPE.ERROR
            };

        case NOTIFICATION_HANDLER.DISPLAY_ERROR:
            return {
                ...state,
                hasNotification: true,
                errorMessageInfo: action.payload,
                notificationType: NOTIFICATION_TYPE.DISPLAY_ERROR
            };

        case NOTIFICATION_HANDLER.INFO:
            return {
                ...state,
                hasNotification: true,
                errorMessageInfo: action.payload,
                notificationType: NOTIFICATION_TYPE.INFO
            };

        case NOTIFICATION_HANDLER.WARNING:
            return {
                ...state,
                hasNotification: true,
                errorMessageInfo: action.payload,
                notificationType: NOTIFICATION_TYPE.WARNING
            };

        case NOTIFICATION_HANDLER.DISMISS_ERROR:
            return {
                ...state,
                hasNotification: false,
                errorMessageInfo: '',
                notificationType: NOTIFICATION_TYPE.ERROR
            };
        default:
            return state;
    }
}
